<template>
  <div>
    <!-- <v-overlay :value="isLoading">
      <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular></v-overlay> -->
    <v-card class="mx-auto">
      <v-toolbar color="indigo" dark>
        <v-app-bar-nav-icon></v-app-bar-nav-icon>
        <v-toolbar-title></v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon>
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-toolbar>

      <v-container fluid>
        <v-row dense>
          
                  <v-col cols="2" sm="2" md="2">
                    <v-select
                    outlined
                      v-model="anolectivo"
                      item-value="idAnoLectivo"
                      item-text="novadescricao"
                      @change="carregarQuantEstudantesEstatistica()"
                      :items="anoLectivos"
                      chips
                      label="Ano Lectivo"
                      return-object
                    ></v-select>
                  </v-col>
                  <v-col cols="6" sm="6" md="6">
                    <v-autocomplete
                        outlined
                        v-model="instituicao"
                        item-value="descricao"
                        item-text="descricao"
                        :items="instituicoespay"
                        label="Instituição/Colégio"
                        :readonly="false"
                        persistent-hint
                        prepend-icon="home"
                        @change="filter()"
                        return-object
                      >
                      </v-autocomplete>
                  </v-col>
        

            <table id="tfhover" class="tftable">
              <tr>
              <th rowspan="2">Nº</th>

              <th rowspan="2">Escola/colégio ({{ estudantes.length }})</th>
              <th colspan="5">Nº Alunos</th>
              <th rowspan="2">PREÇO UN.(AKZ)</th>
              <th rowspan="2">IVA(AKZ)</th>
              <th rowspan="2">TOTAL(AKZ)</th>
              <th rowspan="2">Setembro</th>
              <th rowspan="2">Outubro</th>
              <th rowspan="2">Novembro</th>
              <th rowspan="2">Dezembro</th>
              <th rowspan="2">Janeiro</th>
              <th rowspan="2">Fevereiro</th>
              <th rowspan="2">Março</th>
              <th rowspan="2">Abril</th>
              <th rowspan="2">Maio</th>
              <th rowspan="2">Junho</th>
              <th rowspan="2">Julho</th>
              <th rowspan="2">Agosto</th>

              </tr>
              <tr>
              <td>10ª</td>
              <td>11ª</td>
              <td>12ª</td>
              <td>13ª</td>
              <td>TOTAL</td>
              </tr>
              <tr  v-for="(estudante, index) in estudantes" :key="index">
              <td>{{ index + 1 }}</td>
              <td style="text-align:left">{{ estudante.descricao }}</td>
              <td>{{ estudante.classe1 }}</td>
              <td>{{ estudante.classe2 }}</td>
              <td>{{ estudante.classe3 }}</td>
              <td>{{ estudante.classe4 }}</td>
              <td style="color:#FF5D33">{{ estudante.total }}</td>
              <td style="color:#34b4eb">{{ formatMoney(estudante.valorunitario) }}</td>
              <td style="color:#FF338C">{{ formatMoney(estudante.iva) }}</td>
              <td style="color:#34b4eb">{{ formatMoney(estudante.valorapagar) }}</td>
              <td @click="dialogRegistrarPagamento(estudante,9,estudante.isPago9,estudante.setembroPay)"> <span :class="(estudante.setembroPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.setembroPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,10,estudante.isPago10,estudante.outubroPay)"> <span :class="(estudante.outubroPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.outubroPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,11,estudante.isPago11,estudante.novembroPay)"> <span :class="(estudante.novembroPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.novembroPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,12,estudante.isPago12,estudante.dezembroPay)"> <span :class="(estudante.dezembroPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.dezembroPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,1,estudante.isPago1,estudante.janeiroPay)"> <span :class="(estudante.janeiroPay > 0? 'cursor pago':'cursor npago')" > {{ (estudante.janeiroPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,2,estudante.isPago2,estudante.fevereiroPay)"> <span :class="(estudante.fevereiroPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.fevereiroPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,3,estudante.isPago3,estudante.marcoPay)"> <span :class="(estudante.marcoPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.marcoPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,4,estudante.isPago4,estudante.abrilPay)"> <span :class="(estudante.abrilPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.abrilPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td  @click="dialogRegistrarPagamento(estudante,5,estudante.isPago5,estudante.maioPay)"> <span :class="(estudante.maioPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.maioPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,6,estudante.isPago6,estudante.junhoPay)"> <span :class="(estudante.junhoPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.junhoPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,7,estudante.isPago7,estudante.julhoPay)"> <span :class="(estudante.julhoPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.julhoPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,8,estudante.isPago8,estudante.agostoPay)"> <span :class="(estudante.agostoPay > 0? 'cursor pago':'cursor npago')"> {{ (estudante.agostoPay > 0? 'PAGO':'N/PAGO') }} </span></td>
              <!-- <td @click="dialogRegistrarPagamento(estudante,9,estudante.isPago9,estudante.setembroPay)"> <span :class="estudante.isPagoCss9"> {{ estudante.isPago9 }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,10,estudante.isPago10,estudante.outubroPay)"> <span :class="estudante.isPagoCss10"> {{ estudante.isPago10 }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,11,estudante.isPago11,estudante.novembroPay)"> <span :class="estudante.isPagoCss11"> {{ estudante.isPago11 }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,12,estudante.isPago12,estudante.dezembroPay)"> <span :class="estudante.isPagoCss12"> {{ estudante.isPago12 }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,1,estudante.isPago1,estudante.janeiroPay)"> <span :class="estudante.isPagoCss1" > {{ estudante.isPago1 }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,2,estudante.isPago2,estudante.fevereiroPay)"> <span :class="estudante.isPagoCss2"> {{ estudante.isPago2 }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,3,estudante.isPago3,estudante.marcoPay)"> <span :class="estudante.isPagoCss3"> {{ estudante.isPago3 }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,4,estudante.isPago4,estudante.abrilPay)"> <span :class="estudante.isPagoCss4"> {{ estudante.isPago4 }} </span></td>
              <td  @click="dialogRegistrarPagamento(estudante,5,estudante.isPago5,estudante.maioPay)"> <span :class="estudante.isPagoCss5"> {{ estudante.isPago5 }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,6,estudante.isPago6,estudante.junhoPay)"> <span :class="estudante.isPagoCss6"> {{ estudante.isPago6 }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,7,estudante.isPago7,estudante.julhoPay)"> <span :class="estudante.isPagoCss7"> {{ estudante.isPago7 }} </span></td>
              <td @click="dialogRegistrarPagamento(estudante,8,estudante.isPago8,estudante.agostoPay)"> <span :class="estudante.isPagoCss8"> {{ estudante.isPago8 }} </span></td> -->
              </tr>

              </table>

        </v-row>
      </v-container>
    </v-card>
     <!-- ====================================== Card ========================================== -->

          <template>
            <v-row justify="center">
              <v-dialog v-model="dialog" persistent max-width="1000px">
                <v-card>
                  <!-- <v-overlay :value="$store.state.loading_pdf">
                    <v-progress-circular indeterminate size="64"></v-progress-circular>
                  </v-overlay> -->
                  <v-card-title style="background-color:#006699;color:white;">
                    <span class="text-h5">Detalhes</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container>
                      <v-row>
                        <v-col md="8">
                          <div style="border:1px solid #ccc;">
                            <v-row style="margin-left:10px;">
                              <v-col md="9"><span style="font-weight:bold;size:18px;">Escola/Colégio:</span>
                                <v-chip class="ma-2" style="font-size:12px;"> {{ (editedItem !== null) ? editedItem.descricao : '' }}</v-chip>
                              </v-col>
                              <v-col md="3"><span style="font-weight:bold;size:18px;">Ano Lectivo:</span>
                                <v-chip class="ma-2" style="font-size:12px;"> {{ (editedItem !== null) ? editedItem.anolectivo : '' }}</v-chip>
                              </v-col>
                              <v-col md="6" v-if="!isPago && role === 'ROLE_ADM' && isSoftline"><span style="font-weight:bold;size:18px;">Valor a Pagar:</span>
                                <v-text-field  :rules=" [value => !!value || 'campo obrigatorio']" v-model="valorpago" label=""></v-text-field>
                              </v-col>
                              <v-col md="6" v-if="!isPago && role === 'ROLE_ADM' && isSoftline"><span style="font-weight:bold;size:18px;" >Nº comprovativo:</span>
                                <v-text-field :rules=" [value => !!value || 'campo obrigatorio']" v-model="numerocomprovativo" label=""></v-text-field>
                              </v-col>
                            </v-row>
                          </div>
                        </v-col>
                        <v-col md="4">
                          <v-row>
                            <v-col md="3"></v-col>
                            <v-col md="3">
                            </v-col>
                            <!-- <v-col md="3" v-if="!isPago">
                              <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn color="green" v-bind="attrs" v-on="on" @click="savephoto()">
                                    <v-icon style="color:white;">send</v-icon>
                                  </v-btn>
                                </template>
                                <span>Ré-imprimir a fatura</span>
                              </v-tooltip>
                            </v-col> -->
                            <v-col md="3" >
                              <v-tooltip bottom v-if="!isPago && numerocomprovativo > 0 && isSoftline && role == 'ROLE_ADM'">
                                <template v-slot:activator="{ on, attrs }">
                                  <input @change="previewImage" type="file"  ref="file" style="display: none">
                                  <v-btn v-bind="attrs" v-on="on" @click="$refs.file.click()">
                                    <v-icon>add_a_photo</v-icon>
                                  </v-btn>
                                </template>
                                <span>Anexar comprovativos</span>
                              </v-tooltip>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col md="12">
                          <v-tabs v-model="tab">
                            <v-tab v-for="item in items" :key="item.tab">
                              {{ item.tab }} <v-icon small>{{ item.icon }}</v-icon>
                            </v-tab>
                          </v-tabs>

                          <v-tabs-items v-model="tab">
                            <v-tab-item>
                              <v-card flat>
                                <v-card-text>
                                  <span style="font-weight:bold;font-size:15px;">Items</span><br>
                                  <hr>
                                  <template>
                                    <v-data-table :headers="headersItems" :items="itemsFatura">
                                      <template v-slot:item.valorapagar="{ item }">
                                        <span>{{ formatMoney(item.valorapagar) }}</span>
                                      </template>

                                      <template v-slot:item.valorpago="{ item }">
                                        <span> {{ formatMoney(item.valorpago) }} </span>
                                      </template>
                                      <template v-slot:item.ordem="{ item }">
                                        <span>{{ itemsFatura.indexOf(item) + 1 }}</span>
                                      </template>
                                      <template v-slot:item.estado="{ item }" class="cursor">
                                        <span v-if="!(item.valorapagar <= item.valorpago)" style="color:red">N/PAGO</span>
                                        <span v-if="(item.valorpago > 0 && item.valorapagar > item.valorpago)" style="color:red">Parcialmente Pago</span>
                                        <span v-if="(item.valorapagar <= item.valorpago)" style="color:green">PAGO</span>
                                      </template>

                                    </v-data-table>
                                  </template>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                            <v-tab-item>
                              <v-card flat>
                                <v-card-text>
                                  <span style="font-weight:bold;font-size:15px;">Comprovativos carregados</span><br>
                                  <hr>
                                  <template>
                                    <v-data-table :headers="headerComprovativos" :items="comprovativos">
                                      <template v-slot:item.photo="{ item }">
                                    <img class="photomouse" :src="getPhoto(item)" alt="avatar" width="30px;" />
                                    </template>
                                    <template v-slot:item.mes="{ item }">
                                        <span>{{months[item.mes - 1]}}</span>
                                      </template>
                                      <template v-slot:item.view="{ item }">
                                        <v-tooltip bottom>
                                          <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="#e31084" fab small v-bind="attrs"
                                              v-on="on" @click="downloadFile(item)">
                                              <v-icon style="color:white;" small>arrow_downward</v-icon>
                                            </v-btn>
                                          </template>
                                          <span>Baixar Comprovativo</span>
                                        </v-tooltip>
                                        <!-- <v-btn style="margin-left:20px;" color="red" fab small>
                                          <v-icon style="color:white;" small>delete</v-icon>
                                        </v-btn> -->
                                      </template>
                                    </v-data-table>
                                  </template>
                                </v-card-text>
                              </v-card>
                            </v-tab-item>
                          </v-tabs-items>
                        </v-col>
                      </v-row>
                    </v-container>
                    <small>Copyright - 2021 by Softline, Angola</small>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="savephoto()" v-if="!isPago && numerocomprovativo > 0 && isSoftline && role == 'ROLE_ADM'">
                      Salvar
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="fechar()">
                      Fechar
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-row>
          </template>
          <!-- ====================================== CARD/================================================ -->
          <carregarFoto :instituicao="editedItem" :eventPhoto="eventPhoto" @fecharComponente="fecharTelaComponente" v-if="menuSelected === 1"></carregarFoto>
  </div>
</template>
<script>
import axios from '../../../plugins/axios'
import carregarFoto from '../componentes/administrador/carregarcomprovativo.vue'
import photoUser from '../../../utilitarios/photo.services'
import FileDownload from 'js-file-download'
import Swal from 'sweetalert2'
const ls = require('local-storage')
export default {
  components: {
    carregarFoto
  },
  data: () => ({
    instituicao: null,
    instituicoespay: [],
    isPago: false,
    menuSelected: 0,
    tab: 0,
    items: [
      { tab: 'Cota do mês', icon: 'list' },
      { tab: 'Comprovativos carregados', icon: 'photo_camera' }
    ],
    dialog: false,
    comprovativos: [],
    total: 0,
    anoLectivos: [],
    estudantes: [],
    estudantesByClasse: [],
    anolectivo: { descricao: ls.get('anolectivo'), novadescricao: ls.get('novadescricao') },
    editedItem:
      {
        idPagamento: 0,
        anolectivo: ls.get('anolectivo'),
        classe1: 0,
        classe2: 0,
        classe3: 0,
        classe4: 0,
        descricao: '',
        idinstituicao: 0,
        total: 0,
        valorapagar: 0,
        janeiroPay: 0,
        fevereiroPay: 0,
        marcoPay: 0,
        abrilPay: 0,
        maioPay: 0,
        junhoPay: 0,
        julhoPay: 0,
        agostoPay: 0,
        setembroPay: 0,
        outubroPay: 0,
        novembroPay: 0,
        dezembroPay: 0
      },
    defaulteditedItem:
      {
        idPagamento: 0,
        anolectivo: ls.get('anolectivo'),
        classe1: 0,
        classe2: 0,
        classe3: 0,
        classe4: 0,
        descricao: '',
        idinstituicao: 0,
        total: 0,
        valorapagar: 0,
        janeiroPay: 0,
        fevereiroPay: 0,
        marcoPay: 0,
        abrilPay: 0,
        maioPay: 0,
        junhoPay: 0,
        julhoPay: 0,
        agostoPay: 0,
        setembroPay: 0,
        outubroPay: 0,
        novembroPay: 0,
        dezembroPay: 0
      },
    eventPhoto: null,
    idmes: 0,
    dialogComprovativo: false,
    numerocomprovativo: '',
    dialogoAnexar: false,
    valorpago: null,
    itemsFatura: [],
    headersItems: [
      { text: 'Nº de Ordem.', value: 'ordem' },
      { text: 'Mês', value: 'mes' },
      { text: 'Valor Pago', value: 'valorpago' },
      { text: 'Valor a Pagar', value: 'valorapagar' },
      { text: 'Estado', value: 'estado' }
    ],
    headerComprovativos: [
      { text: 'Ficheiro', value: 'photo' },
      { text: 'Meses', value: 'mes' },
      { text: 'Comprovativo', value: 'numero' },
      { text: 'Baixar', value: 'view' }
    ],
    classes: [
      { id: 1, descricao: '10ª Classe' },
      { id: 2, descricao: '11ª Classe' },
      { id: 3, descricao: '12ª Classe' },
      { id: 4, descricao: '13ª Classe' }
    ],
    months: [
      'Janeiro',
      'Fevereiro',
      'Maço',
      'Abril',
      'Maio',
      'Junho',
      'Julho',
      'Agosto',
      'Setembro',
      'Outubro',
      'Novembro',
      'Dezembro']
  }),
  computed: {
    role(){
      return ls.get('role')
    },
    isSoftline(){
      return ls.get('i_id') === 5
    }
  },
  created () {
    this.initAnoLectivo()
    this.carregarQuantEstudantesEstatistica()
    this.$store.state.novadescricaoSelecionado = ls.get('novadescricao')
  },
  methods: {
    filter(){
      if(this.instituicao)
      this.estudantes = this.instituicoespay.filter(i=>i.idinstituicao === this.instituicao.idinstituicao )
    else
    this.estudantes = this.instituicoespay
    },
    getPhoto (item) {
      try {
        return photoUser.getPhotoComprovativo(item.foto)
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro ao carregar a foto', 'error')
      }
    },
    async downloadFile (item) {
      try {
        await axios({
          url: `${ls.get('urlReport')}readphotoByComprovativo/` + item.foto.replaceAll('/', ''),
          method: 'GET',
          responseType: 'blob' // Important
        }).then(function (response) {
          FileDownload(response.data, item.foto.replaceAll('/', ''))
        })
      } catch (error) {
      }
    },
    async carregarQuantEstudantesEstatistica () {
      this.isLoading = true
      try {
        this.total = 0
        this.instituicoespay = await axios
          .get('/get_config_instituicao_estudantesAllByAnoLectivo/' + this.anolectivo.descricao)
          .then(res => res.data)
          this.filter()
          
        if (this.estudantes.length) {
          this.estudantes.forEach(element => {
            this.total += (element.valorapagar)
          })
        }
      } catch (error) {
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar os dados' })
      } finally {
        this.isLoading = false
      }
    },
    async carregarComprovativosByInstituicao () {
      this.comprovativos = []
      if (this.editedItem.idPagamento > 0) {
        this.isLoading = true
        try {
          this.comprovativos = await axios
            .get('/getComprovativosCota/' + this.editedItem.idPagamento)
            .then(res => res.data)
        } catch (error) {
          Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar os comprovativos' })
        } finally {
          this.isLoading = false
        }
      }
    },
    async dialogRegistrarPagamento (item, mes, status_, valorpago) {
      // if (ls.get('role') === 'ROLE_ADM') {
        try {
          this.idmes = mes
          this.isPago = (status_ === 'PAGO')
          this.editedItem = item
          this.itemsFatura = [ { mes: this.months[mes - 1], valorapagar: item.valorapagar, valorpago: valorpago, estado: status_ } ]
          this.valorpago = (item.valorapagar - valorpago)
          this.carregarComprovativosByInstituicao()
          this.dialog = true
        } catch (error) {
          Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro' })
        } finally {
          this.isLoading = false
        }
      // }
    },
    async savephoto () {
      if (this.$store.state.cropImg) {
        try {
          let fileName = ((new Date().toLocaleDateString()) + '' + new Date().toLocaleTimeString()) + '.png'
          fileName = fileName.replaceAll(':', '')
          let params = { fileName: fileName.replaceAll('/', ''), ficheiro: this.$store.state.cropImg, sigla: '/comprovativo/cota' }
          let result = await axios({ method: 'post', url: ls.get('urlReport') + 'uploadImg', data: params }).then(res => res.data)
          if (result && result.affectedRows > 0) {
            this.registrarPagamento(fileName)
          }
        } catch (error) {
          this.$store.state.cropImg = ''
          Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao realizar a operação' })
        } finally {
          this.$store.state.cropImg = ''
        }
      } else Swal.fire({ icon: 'warning', title: '', text: 'Deve anexar o comprovativo de pagamento' })
    },
    async registrarPagamento (fileName) {
      try {
        let params = {
          mes: this.idmes,
          idinstituicao: this.editedItem.idinstituicao,
          anolectivo: this.editedItem.anolectivo,
          valor: this.valorpago,
          foto: fileName.replaceAll('/', ''),
          numero: this.numerocomprovativo,
          idPagamento: (this.editedItem.idPagamento ? this.editedItem.idPagamento : 0),
          isPago: this.isPago
        }
        let result = await axios.post('/registrarPagamentoCotaByMes', params).then(res => res.data)
        if (result.affectedRows > 0) {
          this.editedItem = this.defaulteditedItem
          this.carregarQuantEstudantesEstatistica()
          Swal.fire({ icon: 'success', title: '', text: `Mês de  ${this.months[this.idmes - 1]} registrado com sucesso` })
        }
      } catch (error) {
        this.dialog = false
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao registrar' })
      } finally {
        this.fechar()
      }
    },
    fechar () {
      this.dialog = false
      this.editedItem = this.defaulteditedItem
      this.valorpago = 0
      this.numerocomprovativo = ''
      this.comprovativos = []
    },
    async initAnoLectivo () {
      try {
        this.anoLectivos = await axios
          .get('/listarAnoLectivoAll')
          .then(res => res.data)
      } catch (error) {
        this.text = error
        Swal.fire({ icon: 'error', title: '', text: 'Ocorreu um erro ao carregar o anolectivo' })
      } finally {
        this.isLoading = false
      }
    },

    formatMoney (value) {
      this.formatter = new Intl.NumberFormat('AOA', {
        style: 'currency',
        currency: 'AKZ'
      })
      var a = this.formatter.format(value)
      return a
    },
    fecharTelaComponente () {
      this.menuSelected = 0
      this.carregarQuantEstudantesEstatistica()
    },
    previewImage: function (event) {
      // Reference to the DOM input element
      this.dialogoAnexar = true
      const file = event.target.files[0]
      if (file.type.indexOf('image/') === -1) {
        Swal.fire({ icon: 'warning', title: '', text: 'Por favor selecione uma imagem' })
      } else {
        if (typeof FileReader === 'function') {
          this.eventPhoto = event
          this.menuSelected = 1
        } else {
          Swal.fire({ icon: 'warning', title: '', text: 'Ficheiro não suportado' })
        }
      }
    },
    visualizarFoto (item) {
      this.file = item.file
      this.itemObject = item
      this.dialogComprovativo = true
    }
  }
}
</script>
<style>
.pago{ color: green}
.npago{ color: red}
.cursor{
  text-decoration: underline;
  cursor: pointer;
}
table.tftable {font-size:12px;color:#333333;width:100%;border-width: 1px;border-color: #729ea5;border-collapse: collapse;text-align:center;}

table.tftable th {font-size:12px;background-color:#acc8cc;border-width: 1px;padding: 8px;border-style: solid;border-color: #729ea5;text-align:center;}
table.tftable tr {background-color:#d4e3e5;}
table.tftable td {font-size:12px;border-width: 1px;padding: 8px;border-style: solid;border-color: #729ea5;text-align:center;}
.tabela {
  border: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 9px !important;
}
.tabelath {
  border: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 9 px !important;
}
.tdsize {
  width: 3px !important;
}
.tdcurrency {
  font-size: 11px !important;
  padding: 0px 0px;
  margin: 0px
}
.v-data-table td,
.v-data-table th {
  padding: 0px 6px;
}

.v-progress-circular {
  margin: 1rem;
}

</style>
